'use client';

import { createContext, useState } from 'react';
import type { Dispatch, ReactNode, SetStateAction } from 'react';
import type { ComponentProps } from 'react';
import type GlobalNavigation from '.';

const NavbarModeContext = createContext<ModeState | null>(null);

function NavbarModeProvider({
	initialMode = 'inline',
	children,
}: {
	initialMode?: NavbarMode;
	children: ReactNode;
}) {
	const [mode, setMode] = useState<NavbarMode>(initialMode);

	return (
		<NavbarModeContext value={{ mode, setMode }}>{children}</NavbarModeContext>
	);
}

export { NavbarModeContext, NavbarModeProvider };

type NavbarMode = ComponentProps<typeof GlobalNavigation>['mode'];

interface ModeState {
	mode: NavbarMode;
	setMode: Dispatch<SetStateAction<NavbarMode>>;
}
